.DialogLoadingFallback {
  display: flex;
  align-items: center;
  justify-content: center;

  .LoadingSpinner {
    color: var(--faded);
    height: 40px;
    width: 40px;
  }
}
